export const isAreaInRange = (forestArea, range) => {
  const { min_ha, max_ha } = range;

  if (max_ha !== undefined) {
    return forestArea >= min_ha && forestArea <= max_ha;
  }

  return forestArea >= min_ha;
};

export const getTotalForestArea = (properties) => {
  if (!properties) return 0; 

  return properties.reduce((total, prop) => total + prop?.forestArea ?? 0, 0);
};

export const mapPropertiesData = (properties) => {
  return properties.map((prop) => {
    const forestLand = prop?.forest_land ?? prop?.data?.forest_land;
    const disabled =
      prop.type != "PROP" ||
      ["broken", "running"].includes(prop?.status) ||
      prop?.data?.overview_classification?.forest_land == 0 ||
      forestLand == 0;

    const designation = disabled
      ? `${prop.designation} - Inte tillgänglig`
      : prop.designation;

    return {
      designation,
      ref: prop.ref,
      forestArea: forestLand,
      plus_price_error: prop?.plus_price_error ?? prop?.data?.plus_price_error ?? 0,
      plus_price: prop?.plus_price ?? prop?.data?.plus_price ?? 0,
      plus_price_max: prop?.plus_price_max ?? prop?.data?.plus_price_max ?? 0,
      type: prop.type,
      lmID: prop?.lmID ?? null,
      dfr: prop?.dfr ?? false,
      hasBadData: prop?.has_bad_data ?? prop?.data?.has_bad_data ?? false,
      disabled,
    };
  });
};

export const saveOrderToCookie = (order) => {
  sessionStorage.setItem("subscription_order", JSON.stringify(order));
};

export const getOrderFromCookie = () => {
  const order = sessionStorage.getItem("subscription_order");
  if (!order) {
    return undefined;
  }
  return JSON.parse(order);
};

export const clearOrderFromCookie = () => {
  sessionStorage.removeItem("subscription_order");
};

export const STEP_NAMES = {
  Order: "order",
  AccountStep: "account",
  Payment: "payment_selection",
  ThankYou: "thank_you",
};

export const getStepName = (StepComponent) =>
  STEP_NAMES[StepComponent?.name] || "unknown";

export const trackSubscriptionCheckoutEvent = (
  action,
  stepName,
  properties
) => {
  const baseTrackingData = {
    category: "subscription",
    step: stepName,
  };

  mixpanel.track(`subscription_checkout:${action}`, {
    ...baseTrackingData,
    ...properties,
  });

  gtag(
    "event",
    "fe_subscription_checkout:" + stepName + ":" + action,
    {
      method: "site",
    }
  );
};
